/** MUI */
import {
    Box,
    Container,
    Grid2 as Grid,
    Typography,
} from "@mui/material";

/** Components */
import classes from "./testimonials.module.css";

const Testimonials = () => {
    return (
        <Box className={classes.testimonials}>
            <Container maxWidth="xl" disableGutters className={classes.containerTest}>
                <Typography variant="h1" color="secondary" textAlign="center" className={classes.mainTitle}>
                    Accounting firms closing their clients' books twice as fast
                </Typography>
                <Grid container spacing={{ xs: 2, md: 3, xxl: 4 }} className={classes.TestContent}>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography color="V003" variant="body1" className={classes.paddingB}>
                            “Noddok has revolutionized my workflow by significantly reducing the time spent on financial
                            statement preparation. With its fast and accurate bank statement conversion, I've reclaimed
                            valuable time for more strategic tasks.”
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            Elani Álvarez<br></br>
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            President, ATAX Inc
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography color="V003" variant="body1" className={classes.paddingB}>
                            “Noddok's AI-powered technology has been a game-changer, incredibly accurate and efficient,
                            automating data extraction from bills and seamlessly synchronizing everything with
                            QuickBooks. I highly recommend it!”
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            Edgard Paredes<br></br>
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            CEO & Founder, Axl Maximus
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>
                        <Typography color="V003" variant="body1" className={classes.paddingB}>
                            “Noddok is an incredibly fast, reliable, user-friendly, and affordable solution. It
                            accurately converts bank statements in seconds, saving me countless hours and ensuring data
                            integrity. I can confidently recommend Noddok”
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            Juan Antonio Cifuentes<br></br>
                        </Typography>
                        <Typography variant="body3" color="secondary">
                            Accountant, Padgett
                        </Typography>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};

export default Testimonials;